import { loadableWithFallback } from '@vision/ui/utils';
import type { CardChart1Props } from './CardChart1';

export const CardChart1 = loadableWithFallback<CardChart1Props>(() => import('./CardChart1'));
